import lazyLoadView from '@router/lazy-loader'
import Constant from '@constants'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    redirect: { name: `${routeNamePrefix}.assetType` },
    meta: {
      moduleName,
      nonLinked: true,
      titleFn(route, translator, pluralTranslator) {
        if (
          route.name.indexOf('.discovery') >= 0 ||
          route.name.indexOf('.agent') >= 0 ||
          route.name.indexOf('.snmp-custom-properties') >= 0 ||
          route.name.indexOf('.ipRangeLocation') >= 0 ||
          route.name.indexOf('.asset-relationship-types') >= 0 ||
          route.name.indexOf('.credentials') >= 0
        ) {
          return `${translator('discovery_and_agents')}`
        }
        if (
          route.name.indexOf('.manufacturer-catalog') >= 0 ||
          route.name.indexOf('.product-type') >= 0 ||
          route.name.indexOf('.product-catalog') >= 0 ||
          route.name.indexOf('.vendor-catalog') >= 0 ||
          route.name.indexOf('.asset-relationship-types') >= 0 ||
          route.name.indexOf('.warranty-sync') >= 0
        ) {
          return `${translator('supplier')} ${translator('management')}`
        }
        if (route.query.moduleName === Constant.CMDB) {
          return `${translator('cmdb')}`
        }
        return `${translator('asset')} ${translator('management')}`
      },
    },
    children: [
      {
        path: 'asset-types',
        name: `${routeNamePrefix}.assettype`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/asset-type-list'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${pluralTranslator('asset')} ${pluralTranslator('type')}`
          },
        },
      },
      {
        path: 'ci-types',
        name: `${routeNamePrefix}.citype`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/asset-type-list'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${pluralTranslator('ci_type')}`
          },
        },
      },
      {
        path: 'asset-types/create',
        name: `${routeNamePrefix}.create-asset-type`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "service-catalog" */ './views/asset-type/asset-type-create'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${pluralTranslator('asset')} ${pluralTranslator('type')}`
          },
        },
      },
      {
        path: 'asset-types/edit/:id',
        name: `${routeNamePrefix}.edit-asset-type`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "service-catalog" */ './views/asset-type/asset-type-edit'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${pluralTranslator('asset')} ${pluralTranslator('type')}`
          },
        },
      },
      {
        path: 'asset-types/custom-fileds',
        name: `${routeNamePrefix}.custom-fileds`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "service-catalog" */ './views/asset-type/custom-fields'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${translator('asset')} ${pluralTranslator('custom_fields')}`
          },
        },
      },
      {
        path: 'asset-types/create-sync-rule',
        name: `${routeNamePrefix}.create-sync-rule`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "service-catalog" */ './views/asset-type/sync-rule-create'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-types/edit-sync-rule/:id',
        name: `${routeNamePrefix}.edit-sync-rule`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "service-catalog" */ './views/asset-type/sync-rule-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'software-type',
        name: `${routeNamePrefix}.software-type`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "admin" */ './views/software-type-list')
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('software_type')}`
          },
        },
      },
      {
        path: 'snmp-custom-properties',
        name: `${routeNamePrefix}.snmp-custom-properties`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "admin" */ './views/snmp-custom-properties-list'
            )
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('snmp_custom_properties')}`
          },
        },
      },
      {
        path: 'manage-baseline',
        name: `${routeNamePrefix}.manage-baseline`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "admin" */ './views/manage-baseline-list'
            )
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('baseline', 2)}`
          },
        },
      },
      {
        path: 'manage-baseline/create',
        name: `${routeNamePrefix}.baseline-create`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "request" */ './views/manage-baseline-create'
            )
          ),
      },
      {
        path: 'manage-baseline/edit/:id',
        name: `${routeNamePrefix}.baseline-edit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/manage-baseline-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'manage-baseline/:id',
        name: `${routeNamePrefix}.baseline-view`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/manage-baseline-view'
            )
          ),
        meta: {},
      },
      {
        path: 'software-category',
        name: `${routeNamePrefix}.software-category`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "admin" */ './views/software-category-list'
            )
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('software')} ${pluralTranslator(
              'category'
            )}`
          },
        },
      },
      {
        path: 'product-type',
        name: `${routeNamePrefix}.product-type`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "admin" */ './views/product-type-list')
          ),
        meta: {
          breadcrumbKey: 'product_type',
        },
      },
      {
        path: 'barcode',
        name: `${routeNamePrefix}.barcode`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "admin" */ './views/barcode-list')
          ),
        meta: {
          breadcrumbKey: 'barcode',
        },
      },
      {
        path: 'qrcode',
        name: `${routeNamePrefix}.qrcode`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "admin" */ './views/qrcode')
          ),
        meta: {
          breadcrumbKey: 'qrcode',
        },
      },
      {
        path: 'rdp-configuration',
        name: `${routeNamePrefix}.rdp-configuration`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "admin" */ './views/rdp-configuration-form'
            )
          ),
        meta: {
          breadcrumbKey: 'rdp_configuration',
        },
      },
      {
        path: 'asset-movement',
        name: `${routeNamePrefix}.asset-movement`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "admin" */ './views/asset-movement/asset-movement-list'
            )
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('asset_movement', 2)}`
          },
        },
      },
      {
        path: 'asset-movement/assettorepair',
        name: `${routeNamePrefix}.movement-assettorepair`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "request" */ './views/asset-movement/asset-to-repair-create'
            )
          ),
      },
      {
        path: 'asset-movement/assetfromrepair',
        name: `${routeNamePrefix}.movement-assetfromrepair`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "request" */ './views/asset-movement/asset-from-repair-create'
            )
          ),
      },
      {
        path: 'asset-movement/assettransfer',
        name: `${routeNamePrefix}.movement-assettransfer`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "request" */ './views/asset-movement/asset-transfer-create'
            )
          ),
      },
      {
        path: 'asset-movement/:id',
        name: `${routeNamePrefix}.movement-view`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/asset-movement/asset-movement-view'
            )
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('asset_movement', 2)}`
          },
        },
      },
      {
        path: 'asset-movement/assettorepair/edit/:id',
        name: `${routeNamePrefix}.movement-sendtorepairedit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/asset-movement/asset-to-repair-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-movement/returnfromrepair/edit/:id',
        name: `${routeNamePrefix}.movement-returnfromrepairedit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/asset-movement/asset-from-repair-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-movement/assettransfer/edit/:id',
        name: `${routeNamePrefix}.movement-assettransferedit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/asset-movement/asset-transfer-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'discovery',
        name: `${routeNamePrefix}.discovery`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "organization" */ './views/discovery')
          ),
        meta: {
          breadcrumbKey: 'discovery',
        },
      },
      {
        path: 'agent',
        name: `${routeNamePrefix}.agent`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "organization" */ './views/agent')
          ),
        meta: {
          breadcrumbKey: 'agent',
        },
      },
      {
        path: 'asset-group',
        name: `${routeNamePrefix}.asset-group`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/asset-group-list'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${translator('asset')} ${pluralTranslator('group')}`
          },
        },
      },
      {
        path: 'ci-group',
        name: `${routeNamePrefix}.ci-group`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/asset-group-list'
            )
          ),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            return `${pluralTranslator('ci_group')}`
          },
        },
      },
      {
        path: 'product-catalog',
        name: `${routeNamePrefix}.product-catalog`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/product-catalog-list-container'
            )
          ),
        meta: {
          breadcrumbKey: 'product_catalog',
        },
      },
      {
        path: 'vendor-catalog',
        name: `${routeNamePrefix}.vendor-catalog`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/vendor-catalog-list'
            )
          ),
        meta: {
          breadcrumbKey: 'vendor_catalog',
        },
      },
      {
        path: 'manufacturer-catalog',
        name: `${routeNamePrefix}.manufacturer-catalog`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/manufacturer-catalog-list'
            )
          ),
        meta: {
          breadcrumbKey: 'manufacturer_catalog',
        },
      },
      {
        path: 'warranty-sync',
        name: `${routeNamePrefix}.warranty-sync`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/warranty-sync-list'
            )
          ),
        meta: {
          breadcrumbKey: 'warranty_sync',
        },
      },
      {
        path: 'warranty-sync/create',
        name: `${routeNamePrefix}.warranty-sync-create`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "request" */ './views/warranty-sync-create'
            )
          ),
      },
      {
        path: 'warranty-sync/edit/:id',
        name: `${routeNamePrefix}.warranty-sync-edit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/warranty-sync-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'software-rules',
        name: `${routeNamePrefix}.software-rules`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/asset-software-rules'
            )
          ),
        meta: {
          breadcrumbKey: 'software_rule',
        },
      },
      {
        path: 'asset-relationship-types',
        name: `${routeNamePrefix}.asset-relationship-types`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/asset-relationship-types'
            )
          ),
        meta: {
          breadcrumbKey: 'relationship_type',
        },
      },
      {
        path: 'ip-range-location',
        name: `${routeNamePrefix}.ipRangeLocation`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "organization" */ './views/ip-range-location'
            )
          ),
        meta: {
          breadcrumbKey: 'ip_range_location',
        },
      },
      {
        path: 'credentials',
        name: `${routeNamePrefix}.credentials`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "organization" */ './views/credentials-list'
            )
          ),
        meta: {
          breadcrumbKey: 'credentials',
        },
      },
      {
        path: 'wake-on-lan',
        name: `${routeNamePrefix}.wake-on-lan`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "asset-management" */ './views/wake-on-lan-scheduler-list'
            )
          ),
        meta: {
          breadcrumbKey: 'wake_on_lan_schedules',
        },
      },
      {
        path: 'wake-on-lan-scheduler/create',
        name: `${routeNamePrefix}.wol-scheduler-create`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "users" */ './views/wake-on-lan-scheduler-create'
            )
          ),
        meta: {},
      },
      {
        path: 'wake-on-lan-scheduler/edit/:id',
        name: `${routeNamePrefix}.wol-scheduler-edit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "users" */ './views/wake-on-lan-scheduler-edit'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-configuration',
        name: `${routeNamePrefix}.asset-configuration`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "users" */ './views/asset-configuration/asset-configuration'
            )
          ),
        meta: {
          breadcrumbKey: 'asset_configuration',
        },
      },
      {
        path: 'create-asset-configuration',
        name: `${routeNamePrefix}.create-asset-configuration`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "users" */ './views/asset-configuration/create'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-configuration-list',
        name: `${routeNamePrefix}.asset-configuration-list`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "users" */ './views/asset-configuration/list'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-configuration-detail',
        name: `${routeNamePrefix}.asset-configuration-detail`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "users" */ './views/asset-configuration/detail'
            )
          ),
        meta: {},
      },
      {
        path: 'asset-configuration/:id',
        name: `${routeNamePrefix}.asset-configuration-view`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/asset-configuration/view'
            )
          ),
        meta: {},
      },
      {
        path: 'edit-asset-configuration/:id',
        name: `${routeNamePrefix}.edit-asset-configuration`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "purchase" */ './views/asset-configuration/edit'
            )
          ),
        meta: {},
      },
      {
        path: 'deployment-policy',
        name: `${routeNamePrefix}.deployment-policy`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "patch-management/views/deployment-policy-configuration" */ '../patch-management/views/deployment-policy-configuration/list'
            )
          ),
        meta: {
          titleFn(_, translator, pluralTranslator) {
            return `${pluralTranslator('deployment_policy')}`
          },
        },
      },
      {
        path: 'geolocation',
        name: `${routeNamePrefix}.geolocation`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "packages" */ './views/geolocation/geolocation'
            )
          ),
        meta: {
          breadcrumbKey: 'geolocation',
        },
      },
    ],
  },
]
